export const ORDER_RETRACTED = {
  contentTab: 'RETRACTED',
  label: 'Commandes rétractées',
  filters: [
    {
      label: 'Status de commandes',
      path: 'status',
      staticName: 'orderStatus',
      checkedItems: [
        'RETRACTATION_IN_PROGRESS',
        'RETRACTED',
        'PARTIALLY_RETRACTED',
      ],
      defaultList: [
        'RETRACTATION_IN_PROGRESS',
        'RETRACTED',
        'PARTIALLY_RETRACTED',
      ],
    },
    {
      label: 'Type de contact',
      checkedItems: ['Professionnel', 'Marketplace', 'Particulier'],
      path: 'contact.store.contactType',
      staticName: 'contactType',
      defaultList: ['Professionnel', 'Marketplace', 'Particulier'],
    },
    {
      label: 'Types de commandes',
      checkedItems: ['ORDER', 'ORDER_SAV', 'INTERNAL', 'PRE_ORDER'],
      path: 'type',
      staticName: 'orderTypes',
      defaultList: ['ORDER', 'ORDER_SAV', 'INTERNAL', 'PRE_ORDER'],
    },
    {
      label: 'Marques',
      checkedItems: [],
      path: 'contact.store.brand',
      staticName: 'brand',
      defaultList: [
        'Casanoov',
        'Cazeboo',
        'Sicaan',
        'LeroyMerlin',
        'Bricoman',
        'Allegro',
        'ePrice',
        'Kaufland',
        'Worten',
        'Bricodepot',
        'Leclerc',
        'Home24',
        'But',
        'ManoMano',
        'Brico',
        'Praxis',
        'Castorama',
        'Hornbach',
        'Amazon',
        'TikTokShop',
      ],
    },
    {
      label: 'Magasins',
      checkedItems: [],
      path: 'contact.store',
      staticName: 'stores',
      defaultList: [],
    },
  ],

  //Need at least 1 option, by default the first option is choosen
  sortOptions: [
    {
      label: 'Date ↓',
      value: {
        createdAt: -1,
      },
    },
    {
      label: 'Date ↑',
      value: {
        createdAt: 1,
      },
    },
  ],
  // by default Dates are in order.dates[props]
  table: [
    {
      label: 'Référence',
      code: 'REF',
      props: 'reference',
    },
    {
      label: 'Date de la commande',
      code: 'DATE',
      props: 'createdAt',
    },
    {
      label: 'Client',
      code: 'CONTACT',
      props: 'contact',
    },
    {
      label: 'Prix de la commande',
      code: 'PRICE',
      props: 'price',
    },
    {
      label: 'Statut de la commande',
      code: 'STATUS',
      props: 'status',
    },
    {
      label: 'Date de rétractation',
      code: 'DATE',
      props: 'retractAt',
    },
    {
      label: 'Motif de rétractation',
      code: 'REASON',
      props: 'orderRetract',
    },
    {
      label: 'Remboursement',
      code: 'REFUND',
      props: 'orderRetract',
    },
  ],
};
